<template>
  <div></div>
</template>

<script>
export default {
  name: 'WechatForm'
}
</script>

<style scoped>

</style>
